import { WhiteTooltip } from '@AMIEWEB/Common';
import { GridCellParams } from '@mui/x-data-grid';
import { Theme } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectEditPreferenceChildrenRows } from 'store/redux-store/placement-mods/selectors';
import { makeStyles } from 'tss-react/mui';
import { isNumber } from '../../../ModificationsUtils';
import { getDisplayValue } from '../utils';

const StyledTootltip = makeStyles()((theme: Theme) => ({
  arrow: {
    '&:before': {
      border: '1px solid #E3DFDF',
    },
    color: theme.palette.components.tooltip.arrowColor,
  },
  truncation: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  tooltipContent: {
    backgroundColor: theme.palette.components.tooltip.backgroundColor,
    border: '1px solid #E3DFDF',
    color: theme.palette.system.errorRed,
    fontWeight: 'normal',
  },
}));

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const CustomTooltipCellRenderer = React.memo(function CustomTooltipCellRenderer(cellParams: any) {
  const { classes } = StyledTootltip();

  const editPreferenceChildrenRequests = useSelector(selectEditPreferenceChildrenRows);
  const rowData = getDisplayValue(cellParams.row.id, editPreferenceChildrenRequests);

  const getTitle = row => {
    return !isNumber(row?.age) ? 'Required' : '';
  };

  return (
    <WhiteTooltip
      arrow={true}
      title={getTitle(rowData)}
      classes={{ tooltip: classes.tooltipContent, arrow: classes.arrow }}
    >
      <span style={!rowData?.age && rowData?.age !== 0 ? { paddingLeft: '40px' } : null} className={classes.truncation}>
        {isNumber(rowData?.age) ? rowData?.age : '--'}
      </span>
    </WhiteTooltip>
  );
});

export const ErrorTootlTipAge = (params: GridCellParams) => {
  return <CustomTooltipCellRenderer {...params} />;
};
